import { render, staticRenderFns } from "./bwcCoupon.vue?vue&type=template&id=665ef7f3&scoped=true"
import script from "./bwcCoupon.vue?vue&type=script&lang=js"
export * from "./bwcCoupon.vue?vue&type=script&lang=js"
import style0 from "./bwcCoupon.vue?vue&type=style&index=0&id=665ef7f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ef7f3",
  null
  
)

export default component.exports